export default __webpack_public_path__ + "static/2-3f63d5b3bbb77485bbf5b2d09859b171.png";